import { createContext } from 'react';

/**
 * @typedef {Object} AdminAuthValue
 * @property {object|null} admin
 * @property {'checking'|'authenticated'|'anonymous'} status
 * @property {(credentials: {email: string, password: string}) => Promise<object>} login
 * @property {() => Promise<void>} logout
 */

export const AdminAuthContext = createContext(/** @type {AdminAuthValue|null} */ (null));
